import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addAccountForStoreApiRequest } from "../../services";
import { TAddAccountForStore } from "../../types";

export const useAddAccountForStoreApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (infoAdd: TAddAccountForStore) =>
      addAccountForStoreApiRequest(infoAdd),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["all-store"],
      });
    },
  });
};
